module.exports = new __parcel__URL__("chat.45bda19b.jpeg").toString();